/* @flow */
import React, { type Node } from 'react';
import { Root, Text } from './styles';

type TProps = {
	value: number,
	type?: 'default' | 'small' | 'cloud' | 'inline',
	text?: string,
};

const RatingMark = ({ value, type, text }: TProps): Node => {
	const getSegment = () => {
		if (value >= 0 && value < 4) return 'low';
		if (value >= 4 && value < 7) return 'middle';
		if (value >= 7) return 'high';
		return null;
	};

	return (
		<Root $type={type} $segment={getSegment()} title={`${Number(value).toFixed(1)} из 10`}>
			{Number(value).toFixed(1)}
			{type === 'cloud' && !!text && <Text>{text}</Text>}
		</Root>
	);
};

RatingMark.defaultProps = {
	type: 'default',
	text: '',
};

export default RatingMark;
